
<template>

    <section class="global-mentorship">
        <div class="panel">
            <div class="panel-heading">
                <h2>Meetings</h2>
            </div>

            <div class="panel-body" v-if="calendarEvents">
                <full-calendar ref="calendar" :self="self" :config="config" :header="calendarHeader" :events="calendarEvents"></full-calendar>
            </div>
        </div>

        <global-meeting-participants
                v-if="participants"
                :participants="participants"
                :link="link"
                :recordingProcessing="recordingProcessing"
                :hasRecording="hasRecording"
                :maxParticipants="maxParticipants"
                @closeModal="participants=null"
                 />
    </section>

</template>

<script>

import GlobalMeetingParticipants from './widgets/GlobalMeetingParticipants';
import globalMeetings from '../services/global-meetings';
import moment from 'moment';

export default {
    data() {
        return {
            meetings:null,
            calendarEvents: null,
            participants: null,
            maxParticipants: null,
            link: null,
            hasRecording:null,
            recordingProcessing: null,
            config: {
                defaultView: 'month',
                droppable: false,
                displayEventTime: false,
                selectable: false,
                unselectAuto: false,
                eventDurationEditable: false,
                self:self,
                firstDay: 1,
                eventRender: function(event, element) {
                    $(element).html($(element).text())
                },
                eventClick: function(event, mouseEvent) {
                    var self = $('#calendar').fullCalendar('option', 'self');
                    let meeting = self.meetings.find((m)=> { return m.id === event.id});
                    self.participants = meeting.global_meeting_participants;
                    self.maxParticipants = meeting.maxParticipants;

                    const now = new Date().getTime();
                    const end = new Date(meeting.endTime).getTime();

                    if (now > end && !meeting.recordingUrl) self.recordingProcessing = true;

                    if (meeting.recordingUrl) {
                        self.link = meeting.recordingUrl;
                        self.hasRecording = true;
                    } else {
                        self.link = meeting.joinUrl;
                        self.hasRecording = false;
                    }

                }
            },
            calendarHeader: {
                left:   'today prev,next',
                center: 'title',
                right:  ''
            }
        }
    },
    components: {
        GlobalMeetingParticipants
    },
    mounted() {
        this.config.self = this;
        this.getGlobalMeetings();
    },
    methods: {
        getGlobalMeetings() {
            globalMeetings.getMine().then((response)=> {
                this.meetings = response.data.meetings;
                let meetingType;
                localStorage.roles.includes('Recruiter') ? meetingType = 'Recruiter' : meetingType = 'Global Mentor';
                this.calendarEvents = response.data.meetings.map((m)=> {
                    let meetingTime = moment.tz(m.startTime,moment.tz.guess()).format('hh:mm a');

                    const diff = moment(m.startTime).diff(new Date(),'hours');
                    
                    if (diff <= 12 && m.global_meeting_participants.length === 0) {
                        meetingTime = 'cancelled';
                    }

                    let meeting = {
                        id: m.id,
                        type:'meeting',
                        start: moment.tz(m.startTime,moment.tz.guess()),
                        end: moment.tz(m.endTime,moment.tz.guess()),
                        title: meetingType + ' Meeting<br>' + meetingTime,
                        color: '#3cf',
                        textColor:'#1a1a1a',
                        type:'meeting',
                        class:'global-meeting'
                    }


                    return meeting;
                });
            });
        }
    },
    computed: {

    }
}
</script>


<style lang="scss" scoped>

</style>

<style lang="scss">
    .global-mentorship .fc-title {
        color:#1a1a1a!important;
    }
</style>



// WEBPACK FOOTER //
// GlobalMentorship.vue?4aad1bd8